import {type List, type Map} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';

import type * as Models from './models';

const domain = 'INSTITUTION_OVERVIEW';

export const {
    action: fetchAll,
    success: fetchAllSuccess,
    failed: fetchAllFailed,
} = createAction(`${domain}/FETCH_ALL`, (institutionId: string) => ({institutionId}));

export const {
    action: fetchInstitutionDepartments,
    success: fetchInstitutionDepartmentsSuccess,
    failed: fetchInstitutionDepartmentsFailed,
} = createAction(
    `${domain}/FETCH_DEPARTMENTS`,
    (institutionId: string) => ({institutionId}),
    (departments: Map<string, Models.Department>) => ({departments}),
);

/**
 * @deprecated use the useStatSettings().openingHours  instead
 */
export const {
    action: fetchInstitutionOpeningHours,
    success: fetchInstitutionOpeningHoursSuccess,
    failed: fetchInstitutionOpeningHoursFailed,
} = createAction(
    `${domain}/FETCH_OPENING_HOURS`,
    (institutionId: string) => ({institutionId}),
    (openingHours: List<Models.OpeningHour>) => ({openingHours}),
);

export const {
    action: fetchTabs,
    success: fetchTabsSuccess,
    failed: fetchTabsFailed,
} = createAction(
    `${domain}/FETCH_TABS`,
    (institutionId: string) => ({institutionId}),
    (tabs: List<Models.Tab>, hasStarredGroups: boolean) => ({
        tabs,
        hasStarredGroups,
    }),
);

export const {action: selectTab} = createAction(`${domain}/SELECT_TAB`, (tabId: string) => ({tabId}));

export const {
    action: fetchBirthdays,
    success: fetchBirthdaysSuccess,
    failed: fetchBirthdaysFailed,
} = createAction(
    `${domain}/FETCH_BIRTHDAYS`,
    (institutionId: string) => ({institutionId}),
    (birthdays: Models.Birthdays) => ({birthdays}),
);

export const {action: leave} = createAction(`${domain}/LEAVE`, () => ({}));
